var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAvailability(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 87.5 87.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.75,0C19.62,0,0,19.62,0,43.75s19.62,43.75,43.75,43.75,43.75-19.62,43.75-43.75S67.88,0,43.75,0ZM43.75,81.25c-20.68,0-37.5-16.82-37.5-37.5S23.07,6.25,43.75,6.25s37.5,16.82,37.5,37.5-16.82,37.5-37.5,37.5ZM62.06,54.73c-.59.98-1.62,1.52-2.68,1.52-.55,0-1.1-.14-1.61-.45l-15.62-9.38c-.94-.57-1.52-1.58-1.52-2.68v-18.75c0-1.73,1.4-3.12,3.12-3.12s3.12,1.4,3.12,3.12v16.98l14.11,8.46c1.48.89,1.96,2.8,1.07,4.29h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvailability);
export default __webpack_public_path__ + "static/media/availability.0a8b4fd5bd604c42f24559ab3652ae49.svg";
export { ForwardRef as ReactComponent };